
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { OrganizationFormValues } from './types';

interface ClientGoalsFormSectionProps {
  form: UseFormReturn<OrganizationFormValues>;
}

export function ClientGoalsFormSection({ form }: ClientGoalsFormSectionProps) {
  return (
    <div>
      <FormField
        control={form.control}
        name="client_goals"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Client Goals</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Qualitative information from kickoff/intake"
                className="resize-none min-h-[150px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
